<template>
  <div>
    <div class="jiu" v-if="gongjiri">
      <!-- 212f44 -->
      <el-menu :collapse-transition="false" :default-active="this.$route.path" mode="horizontal" background-color="gray" text-color="#fff" active-text-color="#fff" style="background:gray">
        <!-- 通过路由遍历出顶部导航栏 -->
        <template v-for="item in routers">
          <!-- 如果路由的子节点大于1并且是可被展示的 -->
          <el-submenu v-if="item.children.length>1&&item.show != false" :index="item.path" :key="item.path">
            <!-- 遍历父节点生成导航 -->
            <template :index="item.path" slot="title">
              <!-- <Icon :className="item.meta.icon"  ></Icon> -->
              <!-- <svg t="1621480227397" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4606" width="200" height="200"><path d="M960.8 511.5c0 247-201.3 449-450.8 448.3-180.8-0.7-342.2-109.7-411.5-273.5-22.6-53.1-35.4-112.5-35.4-174.8 0-247 201.4-448 450.8-447.2 248.5 0.6 446.9 200.9 446.9 447.2z m-448.6-276c-28 0-49.9 22-49.9 50.3 0 27.2 21.9 49.5 49.9 49.5 27.2 0 49.5-22.3 49.5-49.5 0-28.4-22.3-50.3-49.5-50.3z m-49.9 189.3v313.5c0 27.6 22.3 49.9 49.9 49.9 27.2 0 49.9-22.3 49.9-49.9V424.8c0-27.6-22.6-49.9-49.9-49.9-27.6 0-49.9 22.3-49.9 49.9z m51-261.5C319.4 162.6 163 319.7 163 511.5c0 48.5 9.9 94.1 27.6 135.9 53.8 127.4 179 212 319.9 212.3 142.2 0.7 268.9-83.5 323.1-212.3 17.7-41.7 27.9-87.4 27.9-135.9 0-47.4-10.3-93.7-27.9-135.9C780 248.2 654.1 164 513.3 163.3z" fill="#717071" p-id="4607"></path></svg> -->
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="item.meta.icon" style="filter: grayscale(100%);"></use>
                <!-- <use :xlink:href="item.meta.icon" v-else></use> -->
              </svg>
              <span style="margin-left:1px;font-size:16px">{{item.name}}</span>
            </template>
            <!-- 遍历父节点下的子节点生成下拉导航 -->
            <template v-for="child in item.children">
              <router-link :key="child.path" :to="item.path+'/'+child.path">
                <el-menu-item :index="item.path+'/'+child.path" :key="item.path" v-if="child.show != false" class="xiala">
                  <template slot="title">
                    <!-- <Icon :className="child.meta.icon"></Icon> -->

                    <span>{{ child.name }}</span>
                  </template>
                </el-menu-item>
              </router-link>
            </template>
          </el-submenu>
          <!-- 如果路由的子节点小于1并且是可被展示的 -->
          <template v-else-if="item.children.length<=1&&item.show != false">
            <!-- 遍历节点生成导航 -->
            <template v-for="child in item.children">
              <el-menu-item ref='nav' @click="go(item)" :index="item.path+'/'+child.path" :key="child.name">
                <template slot="title">
                  <router-link :to="item.path+'/'+child.path">
                    <!-- <Icon :className="item.meta.icon"  ></Icon> -->
                    <svg class="icon" aria-hidden="true" style="filter: grayscale(100%);">
                      <use :xlink:href="child.meta.icon"></use>
                    </svg>

                    <span style="margin-left:1px;font-size:16px">{{ child.name }}</span>
                  </router-link>
                </template>
              </el-menu-item>
            </template>
          </template>
        </template>

      </el-menu>
    </div>

    <div class="jiu1" v-else>
      <!-- 212f44 -->
      <el-menu :collapse-transition="false" :default-active="this.$route.path" mode="horizontal" background-color="#212f44" text-color="#fff" active-text-color="#fff" style="background:#293c5C">
        <!-- 通过路由遍历出顶部导航栏 -->
        <template v-for="item in routers">
          <!-- 如果路由的子节点大于1并且是可被展示的 -->
          <el-submenu v-if="item.children.length>1&&item.show != false && mainSystem" :index="item.path" :key="item.path">
            <!-- 遍历父节点生成导航 -->
            <template :index="item.path" slot="title">
              <!-- <Icon :className="item.meta.icon"  ></Icon> -->
              <!-- <svg t="1621480227397" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4606" width="200" height="200"><path d="M960.8 511.5c0 247-201.3 449-450.8 448.3-180.8-0.7-342.2-109.7-411.5-273.5-22.6-53.1-35.4-112.5-35.4-174.8 0-247 201.4-448 450.8-447.2 248.5 0.6 446.9 200.9 446.9 447.2z m-448.6-276c-28 0-49.9 22-49.9 50.3 0 27.2 21.9 49.5 49.9 49.5 27.2 0 49.5-22.3 49.5-49.5 0-28.4-22.3-50.3-49.5-50.3z m-49.9 189.3v313.5c0 27.6 22.3 49.9 49.9 49.9 27.2 0 49.9-22.3 49.9-49.9V424.8c0-27.6-22.6-49.9-49.9-49.9-27.6 0-49.9 22.3-49.9 49.9z m51-261.5C319.4 162.6 163 319.7 163 511.5c0 48.5 9.9 94.1 27.6 135.9 53.8 127.4 179 212 319.9 212.3 142.2 0.7 268.9-83.5 323.1-212.3 17.7-41.7 27.9-87.4 27.9-135.9 0-47.4-10.3-93.7-27.9-135.9C780 248.2 654.1 164 513.3 163.3z" fill="#717071" p-id="4607"></path></svg> -->
              <svg class="icon" aria-hidden="true">
                <!-- <use :xlink:href="item.meta.icon" style="filter: grayscale(100%);" v-if="gongjiri"></use> -->
                <use :xlink:href="item.meta.icon"></use>
              </svg>
              <span style="margin-left:1px;font-size:16px">
                <span v-if="item.name=='项目'">{{ $t('route.project') }}</span>
                <span v-if="item.name=='审核'">{{ $t('route.audit') }}</span>
                <span v-if="item.name=='文件'">{{ $t('route.documents') }}</span>
              </span>
            </template>
            <!-- 遍历父节点下的子节点生成下拉导航 -->
            <template v-for="child in item.children">
              <router-link :key="child.path" :to="item.path+'/'+child.path">
                <el-menu-item :index="item.path+'/'+child.path" :key="item.path" v-if="child.show != false" class="xiala">
                  <template slot="title">
                    <!-- <Icon :className="child.meta.icon"></Icon> -->

                    <!-- <span>{{ child.name }}6666</span> -->

                        <span v-if="child.name=='在监测'">{{ $t('route.buildingProj') }}</span>
                        <span v-if="child.name=='已完工'">{{ $t('route.completedProj') }}</span>
                        <span v-if="child.name=='项目管理'">{{ $t('route.projectManagement') }}</span>
                        <span v-if="child.name=='未审核'">{{ $t('route.uncompletedAudit') }}</span>
                         <span v-if="child.name=='已审核'">{{ $t('route.completedAudit') }}</span>
                          <span v-if="child.name=='下载资料'">{{ $t('route.downloadData') }}</span>
                         <span v-if="child.name=='注意事项'">{{ $t('route.attentation') }}</span>
                  </template>
                </el-menu-item>
              </router-link>
            </template>
          </el-submenu>
          <el-submenu v-if="item.children.length>1&&item.show != false && !mainSystem && item.name !='文件'" :index="item.path" :key="item.path">
            <!-- 遍历父节点生成导航 -->
            <template :index="item.path" slot="title">
              <!-- <Icon :className="item.meta.icon"  ></Icon> -->
              <!-- <svg t="1621480227397" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4606" width="200" height="200"><path d="M960.8 511.5c0 247-201.3 449-450.8 448.3-180.8-0.7-342.2-109.7-411.5-273.5-22.6-53.1-35.4-112.5-35.4-174.8 0-247 201.4-448 450.8-447.2 248.5 0.6 446.9 200.9 446.9 447.2z m-448.6-276c-28 0-49.9 22-49.9 50.3 0 27.2 21.9 49.5 49.9 49.5 27.2 0 49.5-22.3 49.5-49.5 0-28.4-22.3-50.3-49.5-50.3z m-49.9 189.3v313.5c0 27.6 22.3 49.9 49.9 49.9 27.2 0 49.9-22.3 49.9-49.9V424.8c0-27.6-22.6-49.9-49.9-49.9-27.6 0-49.9 22.3-49.9 49.9z m51-261.5C319.4 162.6 163 319.7 163 511.5c0 48.5 9.9 94.1 27.6 135.9 53.8 127.4 179 212 319.9 212.3 142.2 0.7 268.9-83.5 323.1-212.3 17.7-41.7 27.9-87.4 27.9-135.9 0-47.4-10.3-93.7-27.9-135.9C780 248.2 654.1 164 513.3 163.3z" fill="#717071" p-id="4607"></path></svg> -->
              <svg class="icon" aria-hidden="true">
                <!-- <use :xlink:href="item.meta.icon" style="filter: grayscale(100%);" v-if="gongjiri"></use> -->
                <use :xlink:href="item.meta.icon"></use>
              </svg>
              <span style="margin-left:1px;font-size:16px">
                  <span v-if="item.name=='项目'">{{ $t('route.project') }}</span>
                <span v-if="item.name=='审核'">{{ $t('route.audit') }}</span>
                <span v-if="item.name=='文件'">{{ $t('route.documents') }}</span>
              </span>
            </template>
            <!-- 遍历父节点下的子节点生成下拉导航 -->
            <template v-for="child in item.children">
              <router-link :key="child.path" :to="item.path+'/'+child.path">
                <el-menu-item :index="item.path+'/'+child.path" :key="item.path" v-if="child.show != false" class="xiala">
                  <template slot="title">
                    <!-- <Icon :className="child.meta.icon"></Icon> -->

                    <span>
                      
                        <span v-if="child.name=='在监测'">{{ $t('route.buildingProj') }}</span>
                        <span v-if="child.name=='已完工'">{{ $t('route.completedProj') }}</span>
                        <span v-if="child.name=='项目管理'">{{ $t('route.projectManagement') }}</span>
                        <span v-if="child.name=='未审核'">{{ $t('route.uncompletedAudit') }}</span>
                         <span v-if="child.name=='已审核'">{{ $t('route.completedAudit') }}</span>
                          <span v-if="child.name=='下载资料'">{{ $t('route.downloadData') }}</span>
                         <span v-if="child.name=='注意事项'">{{ $t('route.attentation') }}</span>
                    </span>
                  </template>
                </el-menu-item>
              </router-link>
            </template>
          </el-submenu>
          <!-- 如果路由的子节点小于1并且是可被展示的 -->
          <template v-else-if="item.children.length<=1&&item.show != false">
            <!-- 遍历节点生成导航 -->
            <template v-for="child in item.children">
              <el-menu-item ref='nav' @click="go(item)" :index="item.path+'/'+child.path" :key="child.name" v-if="mainSystem">
                <template slot="title">
                  <router-link :to="item.path+'/'+child.path">
                    <!-- <Icon :className="item.meta.icon"  ></Icon> -->
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="child.meta.icon"></use>
                    </svg>
                    <span style="margin-left:1px;font-size:16px">

                        <span v-if="child.name=='待处理'">{{ $t('route.pending') }}</span>
                        <span v-if="child.name=='设备'">{{ $t('route.device') }}</span>
                        <span v-if="child.name=='版本及功能说明'">{{ $t('route.versionInfo') }}</span>
                       <span v-if="child.name=='物联网卡管理'">{{ $t('route.decidechongzhi') }}</span>
                      
                      <!-- {{ child.name }}444 -->
                       </span>
                  </router-link>
                </template>
              </el-menu-item>

              <el-menu-item ref='nav' @click="go(item)" :index="item.path+'/'+child.path" :key="child.name" v-if="!mainSystem && child.name!='设备'" :class="child.name=='设备'?'shebei':''">
                <template slot="title" v-if="item.show1">
                  <router-link :to="item.path+'/'+child.path">
                    <!-- <Icon :className="item.meta.icon"  ></Icon> -->
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="child.meta.icon"></use>
                    </svg>
                    <span style="margin-left:1px;font-size:16px">
                       <span v-if="child.name=='待处理'">{{ $t('route.pending') }}</span>
                        <span v-if="child.name=='设备'">{{ $t('route.device') }}</span>
                        <span v-if="child.name=='版本及功能说明'">{{ $t('route.versionInfo') }}</span>
                       <span v-if="child.name=='物联网卡管理'">{{ $t('route.decidechongzhi') }}</span>
                    </span>
                  </router-link>
                </template>
              </el-menu-item>
            </template>
          </template>
        </template>

      </el-menu>
    </div>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Content',
  props: {
    routers: Array
  },
  computed: {
    ...mapGetters([
      'mainSystem',
    ]),
  },
  data() {
    return {
      gongjiri: false,
    }
  },

  methods: {
    //点击节点跳转页面
    go(child) {
      // console.log('11111')
      for (var i in this.$refs.nav) {
        if (this.$refs.nav[i].index.search(child.path) != -1) {
          this.$refs.nav[i].$el.children[0].click()
        }
      }
    },
    DateFormat() {
      let date = new Date(),
        currentDate,
        currentTime,
        seperator = "-", // 如果想要其他格式 只需 修改这里
        month = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        minute =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        second =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      month >= 1 && month <= 9 ? (month = "0" + month) : "";
      day >= 0 && day <= 9 ? (day = "0" + day) : "";
      //当前 日期
      currentDate = month + seperator + day;
      //当前 时间
      currentTime = hour + ":" + minute + ":" + second;
      // 输出格式 为 8-27 14:45:33
      return currentDate + " " + currentTime;
    },
    currenttime() {

      var nowTime = this.DateFormat();
      // 2.设置南京事件公祭日
      var NJ_country_startTime = "12-13 00:00:00";
      var NJ_country_overTime = "12-14 00:00:00";
      //2.设置汶川哀悼开始及结束 是 5月12号凌晨
      var earthquake_startTime = "05-12 00:00:00";
      var earthquake_overTime = "05-12 00:00:00";
      //3.设置汶川哀悼开始及结束 是 5月12号凌晨
      var earthquake1_startTime = "12-13 00:00:00";
      var earthquake1_overTime = "12-14 00:00:00";
      //在这判断时间，时间字符串可以直接判断大小，不过要精确到秒
      if (nowTime >= NJ_country_startTime && nowTime <= NJ_country_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true

      } else if (nowTime >= earthquake_startTime && nowTime <= earthquake_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true
      } else if (nowTime >= earthquake1_startTime && nowTime <= earthquake1_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true
      }

    },

  },
  created() {
    this.currenttime()
  }
}
</script>

<style scoped>
.icon {
  width: 1.6em;
  height: 1.6em;
  margin-right: 2px;
  fill: currentColor;
  overflow: hidden;
}
.xiala {
  width: 125px;
}
a {
  text-decoration: none;
}
.jiu .el-menu--horizontal > .el-menu-item.is-active {
  /* background-color: #161f2d !important;
      border-bottom-color: #161f2d !important; */
  background-color: gray !important;
  border-bottom-color: gray !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
.jiu .el-menu--horizontal > .el-menu-item:hover {
  /* background-color: #161f2d !important;
      border-bottom-color:#161f2d !important; */
  background-color: gray !important;
  border-bottom-color: gray !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
.jiu .el-menu--horizontal > .el-menu-item {
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  background-color: gray !important;
}
.jiu >>> .el-submenu__title {
  height: 37px !important;
  line-height: 32px !important;
  border: none !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  background-color: gray !important;
}
.jiu >>> .el-submenu.is-active > .el-submenu__title {
  height: 37px !important;
  line-height: 30px !important;

  border: none !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  /* background-color: #161f2d !important; */
  background-color: gray !important;
}
.jiu >>> .el-submenu:hover > .el-submenu__title {
  height: 37px !important;
  line-height: 30px !important;
  /* background-color: #161f2d !important; */
  background-color: gray !important;
  border: none !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
.jiu .el-menu-item.is-active {
  /* background-color: #161f2d !important; */
  background-color: gray !important;
}
.jiu .el-menu--horizontal {
  border: none;
  padding-left: 20px;
}
.jiu .el-menu--horizontal > .el-menu-item {
  height: 37px;
  line-height: 30px;
  margin-top: 8px;
  background-color: rgb(255, 255, 255);
}
.jiu .el-submenu {
  position: relative !important;
  top: 8px !important;
  margin: 0 2px !important;
  /* background-color: #161f2d !important; */
  background-color: gray !important;
}
.jiu .el-menu--horizontal.el-menu {
  /* background-color: #212f44 !important; */
  background-color: gray !important;
}
.jiu1 .el-menu--horizontal.el-menu {
  background-color: #212f44 !important;
  /* background-color: gray !important; */
}
.jiu1 .el-menu--horizontal > .el-menu-item.is-active {
  background-color: #161f2d !important;
  border-bottom-color: #161f2d !important;
  /* background-color: gray !important;
  border-bottom-color: gray !important; */
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
.jiu1 .el-menu--horizontal > .el-menu-item:hover {
  background-color: #161f2d !important;
  border-bottom-color: #161f2d !important;
  /* background-color: gray !important;
  border-bottom-color: gray !important; */
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
.jiu1 .el-menu--horizontal > .el-menu-item {
  height: 45px;
  line-height: 45px;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  /* background-color: gray !important; */
  background-color: #161f2d !important;
}
.jiu1 >>> .el-submenu__title {
  height: 37px !important;
  line-height: 32px !important;
  border: none !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  /* background-color: gray !important; */
  background-color: #161f2d !important;
}
.jiu1 >>> .el-submenu.is-active > .el-submenu__title {
  height: 37px !important;
  line-height: 30px !important;

  border: none !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
  background-color: #161f2d !important;
  /* background-color: gray !important; */
}
.jiu1 >>> .el-submenu:hover > .el-submenu__title {
  height: 37px !important;
  line-height: 30px !important;
  background-color: #161f2d !important;
  /* background-color: gray !important; */
  border: none !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important;
}
.jiu1 .el-menu-item.is-active {
  background-color: #161f2d !important;
  /* background-color: gray !important; */
}
.jiu1 .el-menu--horizontal {
  border: none;
  padding-left: 20px;
}
.jiu1 .el-menu--horizontal > .el-menu-item {
  height: 37px;
  line-height: 30px;
  margin-top: 8px;
  background-color: rgb(255, 255, 255);
}
.jiu1 .el-submenu {
  position: relative !important;
  top: 8px !important;
  margin: 0 2px !important;
  background-color: #161f2d !important;
  /* background-color: gray !important; */
}
.shebei {
  padding: 0 !important;
}
/* .jiu .el-menu-item i{
color: white;
 display: inline-block;
    height: 25px;
}
     .jiu .el-menu-item:hover i{
color: #000;
 display: inline-block;
    height: 25px;
    }
    .jiu .el-menu-item.is-active i{
      color: #000;
    display: inline-block;
    height: 25px;
    }
    .jiu .el-submenu__title i{
color: white;
 display: inline-block;
    height: 25px;
}
 .jiu .el-submenu__title:hover i{
color: #000;
 display: inline-block;
    height: 25px;
    }
    
     .jiu .el-submenu.is-active i{
      color: #000;
       display: inline-block;
    height: 25px;
    } */
</style>
<style>
.el-menu--horizontal .el-menu--popup-bottom-start {
  margin-top: 0px !important;
}
.el-menu--horizontal .el-menu--popup {
  min-width: 125px !important;
}
.el-menu.el-menu--horizontal {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/NavMenu/Content.vue